var _path, _mask, _g, _mask2, _g2, _mask3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLudoteca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M6.75 23.25H19.5c2.068 0 3.75-1.682 3.75-3.75V6.75C23.25 4.682 21.568 3 19.5 3H6.75C4.682 3 3 4.682 3 6.75v3.314c0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5V6.75c0-.413.337-.75.75-.75H19.5c.413 0 .75.337.75.75V19.5c0 .413-.337.75-.75.75H6.75c-.413 0-.75-.337-.75-.75v-3.84c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5v3.84c0 2.068 1.682 3.75 3.75 3.75",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pzqx435uva",
    width: 21,
    height: 21,
    x: 27,
    y: 3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.75 3H48v20.25H27.75V3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pzqx435uva)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M37.875 23.25C43.458 23.25 48 18.708 48 13.125c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5c0 3.928-3.197 7.125-7.125 7.125s-7.125-3.197-7.125-7.125S33.947 6 37.875 6c1.904 0 3.692.741 5.038 2.087.586.585 1.537.585 2.122 0 .585-.586.585-1.536 0-2.121C43.122 4.053 40.58 3 37.874 3 32.292 3 27.75 7.542 27.75 13.125S32.292 23.25 37.875 23.25",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "nz5wbwyldb",
    width: 21,
    height: 21,
    x: 3,
    y: 27,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.23 27.282h20.25v20.25H3.23v-20.25z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nz5wbwyldb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M23.04 27.721c-.585-.585-1.536-.585-2.121 0l-7.565 7.565-7.564-7.565c-.585-.585-1.536-.585-2.121 0-.586.586-.586 1.536 0 2.122l7.564 7.564-7.564 7.565c-.586.585-.586 1.535 0 2.12.292.294.676.44 1.06.44s.768-.146 1.06-.44l7.565-7.564 7.565 7.565c.292.293.676.44 1.06.44s.768-.147 1.06-.44c.587-.586.587-1.536 0-2.121l-7.564-7.565 7.565-7.564c.586-.586.586-1.536 0-2.122",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "uu3rmmmr8c",
    width: 20,
    height: 21,
    x: 28,
    y: 27,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.26 27.51H48v19.74H28.26V27.51z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#uu3rmmmr8c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M46.547 27.69c-.882-.367-1.89-.166-2.564.51L28.95 43.233c-.676.675-.875 1.682-.51 2.565.365.882 1.219 1.452 2.174 1.452h4.148c.829 0 1.5-.671 1.5-1.5 0-.828-.671-1.5-1.5-1.5h-2.587L45 31.425V44.25h-3.27c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5h3.917c1.297 0 2.353-1.056 2.353-2.353V29.865c0-.956-.57-1.81-1.453-2.175",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudoteca);
export default __webpack_public_path__ + "static/media/ludoteca.63590a1a823b47ae927b185d47cb89f2.svg";
export { ForwardRef as ReactComponent };